import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);  // null = unknown, false = anon, obj = admin
  const [checking, setChecking] = useState(true);
  const [token, setToken] = useState(() => localStorage.getItem('ayati_admin_token') || '');

  const headers = token ? { Authorization: `Bearer ${token}` } : {};

  const refresh = useCallback(async () => {
    if (!token) {
      setUser(false);
      setChecking(false);
      return;
    }
    try {
      const res = await axios.get(`${API}/api/admin/me`, { headers, withCredentials: true });
      setUser(res.data);
    } catch (_e) {
      setUser(false);
      setToken('');
      localStorage.removeItem('ayati_admin_token');
    } finally {
      setChecking(false);
    }
  }, [token]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const res = await axios.post(
      `${API}/api/admin/login`,
      { email, password },
      { withCredentials: true },
    );
    const newToken = res.data.token;
    setToken(newToken);
    localStorage.setItem('ayati_admin_token', newToken);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/api/admin/logout`, {}, { withCredentials: true, headers });
    } catch (_e) { /* ignore */ }
    setToken('');
    localStorage.removeItem('ayati_admin_token');
    setUser(false);
  };

  const api = axios.create({
    baseURL: API,
    withCredentials: true,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  return (
    <AdminAuthContext.Provider value={{ user, checking, login, logout, api, token }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error('useAdminAuth must be used within AdminAuthProvider');
  return ctx;
};
